import clsx from "clsx"
import React from "react"

import { ImageCover } from "@components/misc"
import { CourseTeacher } from "@interfaces/course"
import { CourseHeading } from "."
import { DetailCard } from "./DetailCard"
import { HARISENIN_PLACEHOLDER } from "@constants/const/pictures"

interface CourseTutorProps {
  tutors: CourseTeacher[]
}

export const CourseTutor: React.FC<CourseTutorProps> = ({ tutors }) => {
  return (
    <section>
      <CourseHeading customMargin="mb-5">Belajar Bersama Tutor Profesional</CourseHeading>

      <div className="grid gap-4">
        {tutors.map((tutor, idx) => (
          <DetailCard
            className="flex sm:gap-[30px] gap-2.5"
            key={idx}
            padding="sm:px-6 py-4 px-2.5 py-2.5"
          >
            <ImageCover
              src={tutor.teacher_picture ?? HARISENIN_PLACEHOLDER}
              alt="tutor"
              size={[100, 100]}
              className={clsx("sm:w-[100px] sm:h-[100px]", "h-[80px] w-[80px]")}
            />
            <div>
              <div className="sm:mb-[14px] mb-2.5">
                <div className={clsx("font-semibold text-black-48 sm-only:text-xs")}>
                  {tutor.teacher_name}
                </div>
                <div className="font-semibold sm-only:text-xxs text-grey-97">
                  {tutor.teacher_last_job}
                </div>
              </div>

              <div title={tutor.teacher_description} className="sm:text-sm text-xxs line-clamp-3">
                {tutor.teacher_description}
              </div>
            </div>
          </DetailCard>
        ))}
      </div>
    </section>
  )
}
